import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { BooksSvg, BurgerMenuSvg, CloseCollapsibleSidebarSvg } from '../../icons';
import { DocumentsPublicType } from '../../pages/EditDocumentCategoryPage/types';
import { BooksLogoTitle, LogosBlock } from '../../pages/Mainpage/styled';
import { routerPath } from '../../router/routerPath';
import { LoginPopup } from '../LoginPopup';
import { CustomSider, SiderItemsContainer } from './styled';

export const ResponsibleNavbar = () => {
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const [documentsState, setDocuments] = useState<DocumentsPublicType>([]);
  const location = useLocation();
  const [popupState, setPopupState] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<DocumentsPublicType>(endpoints.getPublicDocuments());

        setDocuments(response.data);
      } catch (err) {}
    })();
  }, []);

  useEffect(() => setCollapsed(true), [location]);

  return (
    <LogosBlock small>
      <Modal visible={popupState} footer={null} onCancel={() => setPopupState(false)}>
        <LoginPopup />
      </Modal>
      <BooksLogoTitle small>
        <BooksSvg />
        <h1>ФЕДЕРАЛЬНЫЙ ПЕРЕЧЕНЬ УЧЕБНИКОВ</h1>
      </BooksLogoTitle>
      <button className="burger-menu" onClick={() => setCollapsed(!collapsed)}>
        <BurgerMenuSvg />
      </button>
      <CustomSider
        theme="light"
        collapsible
        collapsedWidth={0}
        trigger={null}
        onCollapse={() => setCollapsed(!collapsed)}
        collapsed={collapsed}
        width={'100vw'}
      >
        {!collapsed && (
          <button className="close-button" onClick={() => setCollapsed(true)}>
            <CloseCollapsibleSidebarSvg />
          </button>
        )}
        <SiderItemsContainer>
          <Link className="big" to={routerPath.mainpage}>
            Федеральный перечень учебников
          </Link>
          <Link className="big" to={routerPath.listOfOrganisations}>
            Перечень организаций
          </Link>
          <div className="documents">
            <div className="documents-layout">Документы</div>
            <ul>
              {documentsState.map((el) => (
                <li key={el.id}>
                  <Link to={`${routerPath.document}${el.id}`}>{el.title}</Link>
                </li>
              ))}
            </ul>
          </div>
          <button
            className="auth"
            onClick={() => {
              setPopupState(true);
              setCollapsed(true);
            }}
          >
            Авторизоваться
          </button>
        </SiderItemsContainer>
      </CustomSider>
    </LogosBlock>
  );
};
